import React, { useState, useEffect, useRef, useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import { useDispatch, useSelector } from 'react-redux';
import CONSTANTS from '../util/constants';
import DepartmentModalComp from './DepartmentModalComp';
import Encrypt from './../util/encrypt';

const DepartmentComp = () => {

    const gridRef = useRef();

    const dispatch = useDispatch();
    const rowData = useSelector((state) => state.department.getDepartmentData);


    const [modalShow, isModalShow] = useState(false);
    const [cellData, setCellClickData] = useState(null);
    const [isActive, setIsActive] = useState(false);
    const [useRoleArr, setUserRoleArr] = useState([]);
    const [columnDefs, setColumnDef] = useState([]);
    const [rowDataDepartment, setRowDataDepartment] = useState([]);
    const [loginResponse, setLoginResponse] = useState(null);

    useEffect(() => {

        let localstorageLR = localStorage.getItem("L_R");
        if (localstorageLR) {
            let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : ''
            let loginResponse = localstorageLR ? (JSON.parse(data) != "" || JSON.parse(data) != null) ? JSON.parse(data) : '' : '';
            setLoginResponse(loginResponse);
        }

        setCellClickData(null);

        dispatch({
            type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.GET_DEPARTMENT_API_CALL
        })

    }, []);

    useEffect(() => {

        if (rowData && rowData.length > 0 && rowData != 'Failed') {

            let activeDepartmentData = rowData.filter((item) => item.is_active == true);

            setRowDataDepartment(activeDepartmentData);
        }
    }, [rowData])


    useEffect(() => {

        setColumnDef([
            {
                headerName: 'Department No',
                field: 'department_id', filter: true, resizable: true, flex: 1, width: 100,
                minWidth: 200,
                maxWidth: 200

            },
            {
                headerName: 'Department Name',
                field: 'departmentName', filter: true, resizable: true, flex: 1, width: 100,
                minWidth: 300,
                maxWidth: 400
            },
            {
                headerName: 'Division',
                field: 'division.divisionName', filter: true, resizable: true, flex: 1, width: 100,
                minWidth: 300,
                maxWidth: 400
            },
            {
                headerName:
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        'Actions ' : '', children: [
                            {
                                field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellImageRender, width: 100,
                                minWidth: 300,
                                maxWidth: 300
                            },
                            {
                                field: '', filter: true, resizable: true, flex: 1, cellRenderer: cellCancelImageRender, width: 100,
                                minWidth: 300,
                                maxWidth: 300
                            }
                        ]
            },


        ])

    }, [loginResponse])

    const cellImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?

                <div onClick={() => {
                    setCellClickData(params?.data);
                    setIsActive(true);
                    showModal(true);
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/actions.png')} />
                </div>
                : null

        );
    };

    const cellCancelImageRender = (params) => {

        return (
            loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?

                <div onClick={() => {
                    setCellClickData(params?.data);
                    setIsActive(false);
                    let departmentObj = {
                        "departmentName": params?.data?.departmentName ? params?.data?.departmentName : '',
                        "department_id": params?.data?.department_id,
                        "is_active": false
                    }
                    dispatch({
                        type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.DELETE_DEPARTMENT_API_CALL, payload: { value: departmentObj }
                    })
                }}>
                    <img style={{ marginLeft: 20 }} src={require('./../assets/Dashboard/cancel.png')} />
                </div>
                : null

        );
    };

    const defaultColDef = useMemo(() => ({
        sortable: true,
        resizable: true,
    }));

    const showModal = (isShow) => {
        isModalShow(isShow);
    }

    return (

        <div className='row'>

            {modalShow ? <DepartmentModalComp
                title={cellData != null ? 'Edit Department' : 'Add New Department'}
                show={showModal}
                handleClose={showModal}
                isShow={showModal}
                rowDataUser={cellData}
                is_active={isActive}
                setValue={(value) => {
                    isModalShow(false);
                    if (cellData != null) {
                        setCellClickData(null)
                        dispatch({
                            type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.EDIT_DEPARTMENT_API_CALL, payload: { value: value }
                        })
                    }
                    else {

                        dispatch({
                            type: CONSTANTS.CONSTANTS_DEPARTMENT_MANAGEMENT.ADD_DEPARTMENT_API_CALL, payload: { value: value }
                        })

                    }
                }}
            /> : null}

            <div className='col-md-12 col-sm-12 col-12'>

                {
                    loginResponse && ((loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.ADMIN && loginResponse?.user?.userRoles[0]?.priority) || (loginResponse?.user?.userRoles[0]?.user_role_name == CONSTANTS.CONSTANTS_USER_ROLES.RHADMIN && loginResponse?.user?.userRoles[0]?.priority)) ?
                        <div onClick={() => {
                            isModalShow(true);
                            setCellClickData(null)
                        }} className="col-md-12 col-sm-12 row-4 icon icon-shape icon-l  me-12" style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', margin: '2px 0 2px 0px' }}>
                            <img src={require('./../assets/Dashboard/plus.png')} style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}></img>
                        </div>
                        : null
                }

                <div className="col-md-12 col-sm-12 row-10 ag-theme-alpine" style={{
                    height: '80vh', width: '80vw', margin: 'auto'
                }}>

                    {rowDataDepartment && rowDataDepartment?.length > 0 ?
                        <AgGridReact
                            ref={gridRef}
                            suppressColumnVirtualisation={true}
                            defaultColDef={defaultColDef}
                            animateRows={true}
                            rowSelection='multiple'
                            rowData={rowDataDepartment}
                            columnDefs={columnDefs}>
                        </AgGridReact>
                        : <label>{'No data available'}</label>
                    }
                </div>
            </div>
        </div>
    );
};

export default DepartmentComp;

